import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=7dc63245"
import script from "./companies.js?vue&type=script&lang=js&external"
export * from "./companies.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports